"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/MapProperty
 */

/**
 * @enum {string}
 */
var _default = {
  LAYERGROUP: 'layergroup',
  SIZE: 'size',
  TARGET: 'target',
  VIEW: 'view'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLFVBQVUsRUFBRSxZQURDO0VBRWJDLElBQUksRUFBRSxNQUZPO0VBR2JDLE1BQU0sRUFBRSxRQUhLO0VBSWJDLElBQUksRUFBRTtBQUpPLEMiLCJuYW1lcyI6WyJMQVlFUkdST1VQIiwiU0laRSIsIlRBUkdFVCIsIlZJRVciXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL01hcFByb3BlcnR5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19